;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { PaginatedSaleList, Sale } from '@qogita/canary-client'
import { CanaryClient } from '@qogita/deprecated-canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import {
  queryOptions,
  type UseQueryOptions,
  useSuspenseQuery,
} from '@tanstack/react-query'
import { PAGE_SIZE } from 'src/deprecated/constants'
import { ValidParamsOptions } from 'src/deprecated/types/api'
import { getOrdersQueryKey } from 'src/deprecated/utils/queryKey'
import {
  SaleDestination,
  SaleNextAction,
  SaleSortBy,
} from 'src/deprecated/utils/salesQueryParameter'

type SaleStatus = 'CURRENT' | 'COMPLETED' | 'EXPIRED'

const mapSaleStatus: Record<SaleStatus, Sale['status'][]> = {
  CURRENT: ['NOTIFIED'],
  COMPLETED: ['CLOSED', 'COMPLETED'],
  EXPIRED: ['EXPIRED', 'DECLINED'],
}

type UseGetSalesProps = {
  page: number
  status: SaleStatus
  order?: SaleSortBy
  hasRead?: boolean
  expiredFrom?: string
  destination?: SaleDestination
  nextAction?: SaleNextAction
} & Pick<UseQueryOptions, 'retry' | 'enabled'>

type GetSalesOptions = {
  page: number
  status?: Sale['status'][]
  order?: SaleSortBy
  hasRead?: boolean
  expiredFrom?: string
  destination?: SaleDestination
  nextAction?: SaleNextAction
}

const NextActionsParamsMap: Record<SaleNextAction, ValidParamsOptions> = {
  confirm_quantities: {
    hasSalelineQuantitiesConfirmed: false,
  },
  confirm_shipping: {
    hasSalelineQuantitiesConfirmed: true,
    hasShipments: false,
  },
  download_label: {
    hasSalelineQuantitiesConfirmed: true,
    hasShipments: true,
    hasBookedWithQogita: true,
  },
  invoice_ready: {
    hasInvoiceForDownload: true,
  },
  trigger_payment: {
    hasSalelineQuantitiesConfirmed: true,
    hasShipments: true,
  },
}

const getSales = async ({
  page,
  status,
  hasRead,
  order = 'expired_at',
  expiredFrom,
  destination,
  nextAction,
  canaryClient,
}: GetSalesOptions & {
  canaryClient: CanaryClient
}) => {
  const nextActionParams = nextAction ? NextActionsParamsMap[nextAction] : {}

  return canaryClient.getSales({
    page,
    status,
    order,
    hasRead,
    expiredFrom,
    /*
      destination api mapping
      UK => GB
      EU => EU
     */
    destination: destination === 'UK' ? 'GB' : destination,
    ...nextActionParams,
  })
}

export const getSalesQueryOptions = ({
  page,
  status,
  order,
  hasRead,
  expiredFrom,
  destination,
  nextAction,
  canaryClient,
}: {
  page: number
  status: SaleStatus
  order?: SaleSortBy
  hasRead?: boolean
  expiredFrom?: string
  destination?: SaleDestination
  nextAction?: SaleNextAction
  canaryClient: CanaryClient
}) =>
  // TODO: resolve this by moving to RSC or adding the missing dependency
  // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  queryOptions({
    queryKey: getOrdersQueryKey(
      page,
      status,
      hasRead,
      expiredFrom,
      order,
      destination,
      nextAction,
    ),
    queryFn: () =>
      getSales({
        page,
        status: mapSaleStatus[status],
        hasRead,
        expiredFrom,
        order,
        destination,
        nextAction,
        canaryClient,
      }),
  })

export const useSuspenseGetSales = ({
  page,
  status,
  hasRead,
  expiredFrom,
  order = 'expired_at',
  destination,
  nextAction,
  ...props
}: UseGetSalesProps) => {
  const canaryClient = useCanaryClient()
  const { data } = useSuspenseQuery<
    PaginatedSaleList,
    TypeError | Error
    // TODO: resolve this by moving to RSC or adding the missing dependency
    // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  >({
    queryKey: getOrdersQueryKey(
      page,
      status,
      hasRead,
      expiredFrom,
      order,
      destination,
      nextAction,
    ),
    queryFn: () =>
      getSales({
        page,
        status: mapSaleStatus[status],
        hasRead,
        expiredFrom,
        order,
        destination,
        nextAction,
        canaryClient,
      }),
    ...props,
  })

  return {
    sales: data?.results ?? [],
    totalResults: data?.count ?? 0,
    totalPages: data ? Math.ceil(data.count / PAGE_SIZE) : 0,
  }
}
